import { Form, Formik } from 'formik';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FaExclamationCircle } from 'react-icons/all';
import { useDispatch, useSelector } from 'react-redux';
import { closeAllModals } from '../../../../actions/modalActions';
import { createPaymentCard } from '../../../../actions/paymentActions';
import { ReactComponent as Close } from '../../../../icons/close-button.svg';
import IUserProfileReducer from '../../../../interfaces/reducers/userProfileReducer';
import { IStore } from '../../../../reducers';
import Button from '../../../base/button';
import FormikFieldWrapper from '../../../base/forms/formikFieldWrapper';
import { StyledFormikField } from '../../../base/forms/input';
import { Column, Columns } from '../../../base/grid';
import { A } from '../../../base/typography';
import * as StyledModals from '../myShipmentsModals.styles';
import { paymentOptionInitialValues, paymentOptionSchema } from './paymentOption.schema';

interface Props {}

const PaymentOption: FC<Props> = () => {
	const { t } = useTranslation('myShipments');
	const dispatch = useDispatch<any>();
	const userProfileReducer: IUserProfileReducer = useSelector<IStore, IUserProfileReducer>(
		store => store.userProfileReducer
	);
	const { modalSubmitPending, modalSubmitError, modalSubmitErrorDetails } = userProfileReducer;

	const closeModal = () => {
		dispatch(closeAllModals());
		document.body.style.overflow = 'unset';
	};
	document.body.style.overflow = 'hidden';

	const addPaymentMethod = values => {
		dispatch(
			createPaymentCard(
				values.cardholderName,
				values.cardNumber,
				values.cvc,
				values.expiryDate.substring(0, 2),
				values.expiryDate.substring(values.expiryDate.length - 2)
			)
		);
	};

	return (
		<StyledModals.Wrapper>
			<StyledModals.Heading>
				<div>{t('page-settings.addPaymentOption')}</div>
				<A onClick={closeModal}>
					<Close />
				</A>
			</StyledModals.Heading>
			{modalSubmitError && (
				<StyledModals.ErrorMessage>
					<FaExclamationCircle />
					<div>{modalSubmitErrorDetails !== '' ? modalSubmitErrorDetails : t('genericError')}</div>
				</StyledModals.ErrorMessage>
			)}
			<Formik
				onSubmit={addPaymentMethod}
				initialValues={paymentOptionInitialValues}
				validationSchema={paymentOptionSchema}>
				<Form>
					<Columns>
						<Column>
							<FormikFieldWrapper
								label={`${t('cardholder')} *`}
								name="cardholderName"
								languageComponent="myShipments"
								smallLabel>
								<StyledFormikField
									type="text"
									id="cardholderName"
									name="cardholderName"
									placeholder={t('cardholderPlaceholder')}
									autoComplete="name"
								/>
							</FormikFieldWrapper>
						</Column>
					</Columns>
					<Columns>
						<Column>
							<FormikFieldWrapper
								label={`${t('cardnumber')} *`}
								name="cardNumber"
								languageComponent="myShipments"
								smallLabel>
								<StyledFormikField
									type="text"
									id="cardNumber"
									name="cardNumber"
									placeholder={t('cardnumberPlaceholder')}
								/>
							</FormikFieldWrapper>
						</Column>
					</Columns>
					<Columns>
						<Column mobile={1 / 2}>
							<FormikFieldWrapper
								label={`${t('expiryDate')} *`}
								name="expiryDate"
								languageComponent="myShipments"
								smallLabel>
								<StyledFormikField
									type="text"
									id="expiryDate"
									name="expiryDate"
									placeholder={t('expiryDatePlaceholder')}
								/>
							</FormikFieldWrapper>
						</Column>
						<Column mobile={1 / 2}>
							<FormikFieldWrapper
								label={`${t('cvc')} *`}
								name="cvc"
								languageComponent="myShipments"
								smallLabel>
								<StyledFormikField
									type="text"
									id="cvc"
									name="cvc"
									placeholder={t('cvcPlaceholder')}
									autoComplete="off"
								/>
							</FormikFieldWrapper>
						</Column>
					</Columns>
					<Button primary type="submit" isLoading={modalSubmitPending}>
						{t('save')}
					</Button>
				</Form>
			</Formik>
		</StyledModals.Wrapper>
	);
};

export default PaymentOption;
